import moment, { Moment } from 'moment';

export const removeDuplicatedTime = (key: string, time: Moment[] | null, schedule: any[]) => {
  if (time) {
    const [from, to] = time;
    const currentDay = schedule.find(({ value }) => {
      if (value) {
        const [timeFrom, timeTo] = value;
        return moment(timeFrom).isSame(from) && moment(timeTo).isSame(to);
      }
      return null;
    });

    return currentDay && currentDay.day !== key;
  }
};
